<template>
  <div  class="modal-open">
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ userDetails.username }} {{ getTranslations.home_modals_unsubscribe_choice_in_level }}</h1>
          <img class="modal_icon_main" src="/static/images/resub-prize.png" alt="">
          <p> {{ getTranslations.home_modals_unsubscribe_choice_if_you }} </p>
          <div class="modal_middle_title">
            <h1>{{ getTranslations.home_modals_unsubscribe_choice_do_you_want }}</h1>
          </div>
        </div>
        <div class="modal__footer">
          <a class="ti_btn--main" @click="unsubscribe" style="cursor:pointer">
              {{ getTranslations.home_modals_unsubscribe_choice_unsubscribe }}
          </a>
          <br><br>
          <a class="ti_btn--second" @click="noUnSubscribe" style="cursor:pointer">
              {{ getTranslations.home_modals_unsubscribe_choice_cancel }}
          </a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import modals from '../../../common/modals';
import Resubscribe from './Resubscribe';
import ResubscribeGameSms from './ResubscribeGameSms';

export default {
  // modal_unsubscribe.html
  name: 'unsubscribe',
  data() {
    return {
      isIos: false,
    };
  },
  components: {
    Resubscribe,
    ResubscribeGameSms,
  },
  created() {
    console.log('in Unsub created hook');
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForSettings',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapActions('common', [
      'optoutCall',
    ]),
    noUnSubscribe() {
      modals.hideModal(this);
    },
    unsubscribe() {
      this.optoutCall().then(() => {
        this.getUserLoginDetails().then(() => {
          if (this.userDetails.subscribed) {
            modals.hideModal(this);
          } else {
            if (this.subAndUnsubViaSMS && (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS')) {
              this.storeModalForSettings(ResubscribeGameSms);
            } else {
              this.storeModalForSettings(Resubscribe);
            }
            modals.showHideModal(this);
          }
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>

<style type="text/css">
  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/modals/Unsubscribe.vue